import React from "react";
import "../../Components/404NotFound.css";

const SuccsessfullFormSubmit = () => {
  return (
    <div className="notfound-container">
      <img
        src="/img/majesteye-icon-skeye-form-horizontal-white-background.svg"
        alt="SkeyeForm Logo"
        style={{ height: "150px" }}
      />
      <img
        src="/img/green-check-mark.png"
        alt="Success"
        style={{ width: "100px", height: "100px" }}
      />
      <h1 className="notfound-title">Form Submitted Successfully</h1>
      <p className="notfound-message">
        Thank you for submitting the form. Your response has been recorded
        successfully.
      </p>
    </div>
  );
};

export default SuccsessfullFormSubmit;
